export default function setupHeadingObserver( headingScope, containerScope = '.page-content' ) {
	if ( ! headingScope ) {
		return;
	}

	const headingObserver = new IntersectionObserver( changes => {
		changes.forEach( change => {
			const link = document.querySelector( `a[href="#${ change.target.id }"]` );
			if ( link ) {
				if ( change.isIntersecting ) {
					change.target.classList.add( 'in-view' );
					link.classList.add( 'is-current' );
				} else {
					change.target.classList.remove( 'in-view' );
					link.classList.remove( 'is-current' );
				}
			}
		} );
	}, {
		rootMargin: `-25% 0px -50%`,
	} );

	document.querySelectorAll( headingScope ).forEach( heading => {
		heading.classList.add( 'has-scrollspy' );
		// Either the heading or it's topmost container (e.g. columns)
		const target = heading.closest( `${ containerScope } > *` );

		// Create a wrapper, append all children until the next valid heading
		const wrapper = document.createElement( 'div' );
		wrapper.classList.add( 'scrollspy-group' );

		const siblings = [];
		let element = target.nextSibling;
		while ( element && element.nodeType !== 9 ) {
			if ( element.nodeType === 1 ) {
				if ( element.matches( headingScope ) || !! element.querySelector( headingScope ) ) {
					break;
				}

				siblings.push( element );
			}

			element = element.nextSibling;
		}

		// Insert wrapper after heading, the put heading inside it
		target.insertAdjacentElement( 'afterend', wrapper );
		wrapper.append( target, ...siblings );

		// Transfer id from heading to wrapper
		wrapper.id = heading.id;
		heading.removeAttribute( 'id' );

		// Observer wrapper instead of heading
		headingObserver.observe( wrapper );
	} );
}
